import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WeeksSection from './components/WeeksSection';
import WhatYouGetSection from './components/WhatYouGetSection';
import TransformationSection from './components/TransformationSection';
import AcceleratorSection from './components/AcceleratorSection';
import DifferencesSection from './components/DifferencesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';
import { useSEO, getOrganizationSchema, getServiceSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.21daybusinesswebsite.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getServiceSchema(),
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: 'THE 21-DAY BUSINESS WEBSITE™',
        description: 'Création de sites web business professionnels en 3 semaines',
        publisher: {
          '@id': `${siteUrl}/#organization`
        }
      }
    ]
  };

  useSEO({
    title: 'THE 21-DAY BUSINESS WEBSITE™ - Site Web Business Professionnel en 3 Semaines',
    description: 'Créez votre site web business professionnel en seulement 21 jours. Design premium, stratégie de conversion, rédaction pro et SEO optimisé. Transformez votre présence digitale avec notre méthode éprouvée.',
    keywords: 'création site web, site business, site professionnel, design web, SEO, stratégie digitale',
    canonical: siteUrl,
    schema
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main className="pt-20">
        <HeroSection />
        <TransformationSection />
        <WeeksSection />
        <WhatYouGetSection />
        <AcceleratorSection />
        <DifferencesSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
